import Clarity from '@microsoft/clarity';
import { defineNuxtPlugin } from '~/.nuxt/imports';

export default defineNuxtPlugin(({ $config }) => {
  // Apparently, you need to use the config exposed to the client since this is client-only
  if (process.client && $config.clarityProjectId) {
    Clarity.init($config.clarityProjectId);

    // The v2 API is not present in the package ATM
    window.clarity('consentv2', {
      ad_Storage: "denied",
      analytics_Storage: "denied"
    });
  }
});
